<div matDialogTitle>
  {{ 'BULK_BATCHES' | translate }}

  <button
    aria-label='close'
    mat-dialog-close
    mat-icon-button
    matSuffix
  >
    <mat-icon>close</mat-icon>
  </button>
</div>

<div mat-dialog-content>
  <rs-file-uploader
    #fileUploader
    class='mt-40px'
    showErrorsWithRsMessageHandler
    showUploadProgress
    allowMultiUpload="false"
    showUploadedFiles
    (isReadyToUpload)="isBatchReadyToUpload= $event;"
    (uploadDone)="clearBatchFileType($event);"
    [acceptedFileTypes]="['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']"
  ></rs-file-uploader>

  <mat-form-field
    class="mt-40px"
    rsAddClearFormFieldButton
  >
    <mat-label>{{ 'FILE_TYPE' | translate }}</mat-label>
    <mat-select
      data-testid="fileType"
      [formControl]="fileTypeControl"
    >
      @for (option of fileTypeOptions; track option) {
      <mat-option [value]="option">
        {{ option | translate }}
      </mat-option>
      }
    </mat-select>

    @if (fileTypeControl.hasError('required')) {
    <mat-error>
      {{ 'ERROR_MSG.REQUIRED_FIELD' | translate }}
    </mat-error>
    }
  </mat-form-field>
</div>

<div mat-dialog-actions>
  <button
    rsButtonSpinner
    #rsButtonSpinner="rsButtonSpinner"
    (click)="uploadBatchFile(rsButtonSpinner)"
    [disabled]="!isBatchReadyToUpload || fileTypeControl.invalid"
    class='rs-btn--primary'
    data-testid='bulk-batch-upload-button'
    mat-button
  >
    {{ 'UPLOAD' | translate }}
  </button>
</div>